import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageRewardsComponent } from './manage-rewards/manage-rewards.component';
import { ManageExpertsRewardsComponent } from './manage-experts-rewards/manage-experts-rewards.component';
import { SessionRewardsComponent } from './session-rewards/session-rewards.component';

const routes: Routes = [
  {
    path: 'manage-rewards',
    component: ManageRewardsComponent,
  },
  {
    path: 'manage-experts-rewards',
    component: ManageExpertsRewardsComponent,
  },
  {
    path: 'session-rewards',
    component: SessionRewardsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LedgerRoutingModule {}
